// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.client.enterpriseanalytics.enums.AnalyticsNumBedroomType

export enum AnalyticsNumBedroomType {
  ALL = 'ALL',
  FOUR_PLUS_BEDROOM = 'FOUR_PLUS_BEDROOM',
  ONE_BEDROOM = 'ONE_BEDROOM',
  STUDIO = 'STUDIO',
  THREE_BEDROOM = 'THREE_BEDROOM',
  TWO_BEDROOM = 'TWO_BEDROOM',
}

export const AnalyticsNumBedroomType_values = [
  AnalyticsNumBedroomType.ALL,
  AnalyticsNumBedroomType.FOUR_PLUS_BEDROOM,
  AnalyticsNumBedroomType.ONE_BEDROOM,
  AnalyticsNumBedroomType.STUDIO,
  AnalyticsNumBedroomType.THREE_BEDROOM,
  AnalyticsNumBedroomType.TWO_BEDROOM,
] as const;
